import React from 'react';
import { useAppSelector} from "../../creator-presets/DAL/store";
import Imgix from "react-imgix";
import ShareIcons from "./share-icons";
import CreatorDetails from "./creator-details";
import LikesPluginsMacros from "./likes-plugins-macros";
import HearOnYourTrack from "./hear-on-your-track";
import {DEFAULT_PRESET_IMAGE_PATH} from "../../common/constants";
import {getEpochFromDate} from "../../common/services/logic-provider";
import PresetIcons from "./preset-icons";


const PresetDetailsLg = () => {

    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const mainPreset = useAppSelector((store) => store.mainPreset);


    return (
        <div className="w-full">
            <div className="w-full flex items-center justify-between">
                <div className="flex flex-row items-center">
                    <span><PresetIcons width={"30"} algType={mainPreset.algType}/></span>
                    <h1 className="waves-h2 pl-2">
                        {mainPreset.presetName}
                    </h1>
                </div>

                <div className="flex items-center">
                    <ShareIcons />
                </div>
            </div>
            <div className="w-full flex">
                <div className="flex-1">
                    <CreatorDetails cancelImgLazyload={true} />
                    <LikesPluginsMacros />
                    <HearOnYourTrack />
                </div>
                <div>
                    {mainPreset.imgExt.length > 0 ?
                        <Imgix
                            src= {imgCdnDomain + "/images/studioverse/presets/"+ mainPreset.imgGUID + "."
                                +  mainPreset.imgExt
                                + "?epoch=" + getEpochFromDate(mainPreset.imgLastModified) }
                            sizes={"auto"}
                            width={400}
                            height={300}
                            imgixParams={{ fit: "crop" }}
                            htmlAttributes={{
                                alt: `Image for ${ mainPreset.presetName }`
                            }}
                        />
                    :
                        <Imgix
                            src= {imgCdnDomain + DEFAULT_PRESET_IMAGE_PATH }
                            sizes={"auto"}
                            width={400}
                            height={300}
                            imgixParams={{ fit: "crop" }}

                            htmlAttributes={{
                                alt: `Image for ${ mainPreset.presetName }`
                            }}
                        />
                    }

                </div>
            </div>

        </div>

    )
};

export default PresetDetailsLg;